import { render } from "./EditPlayerModal.vue?vue&type=template&id=3c82e7a2"
import script from "./EditPlayerModal.vue?vue&type=script&lang=js"
export * from "./EditPlayerModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\diloti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__